"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "player_home_block--underground-tokens" };
const _hoisted_2 = { class: "underground-tokens" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_underground_token = (0, vue_1.resolveComponent)("underground-token");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.underworldData.tokens, (token, idx) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_underground_token, {
                    token: token,
                    key: idx,
                    location: "player-home"
                }, null, 8, ["token"]));
            }), 128))
        ])
    ]));
}
